import { Link } from "react-router-dom";
import { openCookieSettings } from "@/lib/consent";

export function LegalH2({ children }) {
    return (
        <h2 className="font-serif text-2xl sm:text-3xl text-gold mt-12 mb-4">{children}</h2>
    );
}

export function LegalP({ children }) {
    return <p className="text-zinc-300 font-light leading-relaxed mb-4">{children}</p>;
}

export function LegalUL({ children }) {
    return (
        <ul className="list-disc pl-6 space-y-2 text-zinc-300 font-light mb-4">{children}</ul>
    );
}

export default function LegalLayout({ title, eyebrow, children }) {
    return (
        <main className="min-h-screen bg-ink-900 text-white">
            {/* Header */}
            <header
                className="border-b border-white/10 backdrop-blur-xl"
                style={{ background: "rgba(14, 22, 38, 0.9)" }}
            >
                <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
                    <Link
                        to="/"
                        data-testid="legal-home-link"
                        className="font-serif text-lg text-white hover:text-gold transition-colors"
                    >
                        Santi <span className="text-gold">Lorenzo</span>
                    </Link>
                    <Link
                        to="/"
                        className="text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-gold transition-colors"
                    >
                        ← Volver al inicio
                    </Link>
                </div>
            </header>

            {/* Content */}
            <article className="max-w-3xl mx-auto px-6 py-16">
                {eyebrow && (
                    <p className="text-[11px] tracking-[0.3em] uppercase text-gold/80 mb-4">
                        {eyebrow}
                    </p>
                )}
                <h1 className="font-serif text-4xl sm:text-5xl text-white leading-tight mb-8">
                    {title}
                </h1>
                <div className="text-base">{children}</div>
            </article>

            {/* Footer */}
            <footer className="border-t border-white/10 py-10 px-6">
                <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-zinc-500 tracking-wider">
                        © {new Date().getFullYear()} — Desactiva el Patrón
                    </p>
                    <nav className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-zinc-400">
                        <Link to="/aviso-legal" className="hover:text-gold transition-colors">
                            Aviso legal
                        </Link>
                        <Link
                            to="/politica-de-privacidad"
                            className="hover:text-gold transition-colors"
                        >
                            Política de privacidad
                        </Link>
                        <Link
                            to="/politica-de-cookies"
                            className="hover:text-gold transition-colors"
                        >
                            Política de cookies
                        </Link>
                        <button
                            onClick={openCookieSettings}
                            data-testid="footer-configure-cookies"
                            className="hover:text-gold transition-colors"
                        >
                            Configurar cookies
                        </button>
                    </nav>
                </div>
            </footer>
        </main>
    );
}
